import React from "react";
import { IGatsbyImageData } from "gatsby-plugin-image";
import { ReactComponent as PlayButton } from "img/icons/play-button.svg";
import GatsbyImageTag from "components/partials/parts/gatsby-image-tag";

/**
 * suggested image size 1194x676
 */
type FeatureVideoProps = {
    url: string;
    image?: IGatsbyImageData;
    alt?: string;
    thumbnailUrl?: string;
    thumbnailHeight?: number;
    thumbnailWidth?: number;
    onPlayButtonClick?: () => void;
};

const FeatureVideo: React.FC<FeatureVideoProps> = ({ url, image, alt, thumbnailUrl, thumbnailHeight, thumbnailWidth, onPlayButtonClick }) => {

    return (
        <div className="pattern">
            <div className="container container--md">
                <a className="video-image-link" onClick={onPlayButtonClick} href={`javascript:void(0)`}>
                    {image && <GatsbyImageTag image={image} alt={alt} />}
                    {thumbnailUrl && <img src={thumbnailUrl} alt={alt} height={thumbnailHeight} width={thumbnailWidth} />}
                    <div className="play-btn">
                        <PlayButton />
                    </div>
                </a>
            </div>
        </div>
    );
};

export default FeatureVideo;